export type MunicipalityLabelSource = {
  name?: string | null;
  state?: string | null;
  classification?: string | null;
};

/**
 * Customer-facing municipality label: `Name, ST` when state is present.
 * Keep this aligned with Municipality#canonical_jurisdiction, the backend
 * source of truth for the same string in prompts.
 *
 * State-classified rows omit the suffix so "Arkansas" does not render as
 * "Arkansas, AR". Do not infer this from the place name: cities such as
 * New York, NY must keep the suffix. canonical_jurisdiction still always
 * joins for prompts.
 */
export function formatMunicipalityLabel(
  municipality: MunicipalityLabelSource | null | undefined,
): string {
  if (!municipality) return "";
  if (municipality.classification?.toString().trim().toLowerCase() === "state") {
    return municipality.name ?? "";
  }
  return [municipality.name, municipality.state].filter(Boolean).join(", ");
}
